import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllCombosService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";
  const allCombosService = useQuery({
    queryKey: [
      ...CACHE_KEYS.COMBOS,
      page,
      debouncedQuery,
      per_page,
      created_between,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.COMBOS,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          include: "plan.partner,plan.policies",
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    states: { searchQuery, setSearchQuery },
    services: { allCombosService },
  };
};
